import {
  JOURNEY_BRANCH_NODES,
  JOURNEY_ENTRY_NODES,
} from "src/pages/journeys/constants";
import type { ExecutableJourneyNode } from "src/pages/journeys/types";

/**
 * Get all selected nodes. Default params exclude branch and entry nodes
 */
export const getSelectedNodes = (
  nodes: ExecutableJourneyNode[],
  opts?: {
    includeEntry: boolean;
    includeBranches: boolean;
  },
): ExecutableJourneyNode[] => {
  const selected: ExecutableJourneyNode[] = nodes.filter((node) =>
    Boolean(node.selected),
  );
  const { includeEntry = false, includeBranches = false } = opts || {};

  if (includeBranches && includeEntry) {
    return selected;
  }

  return selected
    .filter(
      (node) =>
        !includeEntry && !JOURNEY_ENTRY_NODES.includes(node.data.config.type),
    )
    .filter(
      (node) =>
        !includeBranches &&
        !JOURNEY_BRANCH_NODES.includes(node.data.config.type),
    );
};
